import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { PlatformService } from '../native/platform.service';

/**
 * On the phone app, the home page is POS overview. Desktop still opens Dashboard.
 */
export const nativePosOverviewGuard: CanActivateFn = (route: ActivatedRouteSnapshot): boolean | UrlTree => {
  const platform = inject(PlatformService);
  if (!platform.isNative) return true;

  const router = inject(Router);
  const fromRoute = route.paramMap.get('parkingId');
  const stored =
    sessionStorage.getItem('parking_id') ||
    sessionStorage.getItem('selectedParkingId') ||
    localStorage.getItem('parking_id') ||
    localStorage.getItem('selectedParkingId');
  const parkingId = (fromRoute || stored || '').trim();

  if (parkingId && parkingId !== 'dashboard') {
    return router.createUrlTree(['/parking', parkingId, 'pos-overview']);
  }
  return router.createUrlTree(['/pos-overview']);
};
